module.exports = __webpack_public_path__ + "img/twitter_akikun_oiwai.eb4e0e3b.png";